import e from"react";var r=e.createContext(),t=function(t){return e.createElement(r.Provider,{value:t.theme},t.children)};export{r as ThemeContext,t as ThemeProvider};
